/**
 * Resolve the caller's IANA timezone via the standard `Intl` API.
 *
 * Works on:
 * - All modern browsers (`Intl.DateTimeFormat` is universally supported).
 * - React Native with Hermes / new architecture
 *   (`Intl.DateTimeFormat().resolvedOptions().timeZone` returns the
 *   device timezone on iOS / Android).
 *
 * The returned string is fed into the SDK's `x-timezone` header so
 * server-side date defaults (pickup window, agent confirmation prose)
 * match the caller's wall-clock instead of falling back to
 * `CONFIG.time.defaultTimezone` (`Asia/Riyadh`).
 *
 * Returns `null` when the runtime doesn't expose `Intl` (very old
 * RN builds without Hermes) so the backend default kicks in.
 */
export function getDeviceTimezone(): string | null {
  try {
    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
      return null;
    }
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz && tz.length > 0 ? tz : null;
  } catch {
    return null;
  }
}
